export default __webpack_public_path__ + "static/media/de-id-cal-data.7a311c3d.ics";